<div class="prompt-container">
    <h1 mat-dialog-title>Welcome to {{basicInfo.restaurantName}}</h1>
    <p>Please verify your age to enter.</p>
    <p>Are you 21 years or older ?</p>
    <div mat-dialog-actions align="center">
        <button mat-button class="btn" [mat-dialog-close]="true">Yes</button>
        <button mat-flat-button color="warn" (click)="redirectToTastio()">No</button>
    </div>
</div>
